<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header"  style="background-color: #1a202e !important;">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" role="button" aria-label="Abrir menú" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink={{homePage}}>
        <!--img style="width: 121px;height: 38px;" [src]="empresaObj?.empresa_urllogo || 'assets/images/logoiturriapprrhh.png'" alt="" /-->
        <img class="logo-barra" [src]="'assets/images/logoiturriapprrhh.png'" alt="ITURRIAPP RRHH" />
        <!--<span class="logo-name" style="color: #e6e6e6 !important;">ITURRIAPP</span>-->
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <mat-icon>menu</mat-icon>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">

        <!--li class="fullscreen m-r-10" style="min-width: 350px;">
            <mat-form-field class="example-full-width my-auto" appearance="outline">
                <mat-select [(ngModel)]="empresaObj" (ngModelChange)="changeEmpresa()">
                    <mat-option *ngFor="let empresa of empresaList" [value]="empresa">
                        {{empresa.empresa_razon}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </li-->
          <li class="empresa-selector-wrapper">
              <mat-form-field class="empresa-selector" appearance="outline">
                  <mat-icon matPrefix aria-hidden="true">business</mat-icon>

                  <mat-select
                          [(ngModel)]="empresaObj"
                          (ngModelChange)="changeEmpresa()"
                          [compareWith]="compararEmpresa"
                          aria-label="Empresa"
                          panelClass="empresa-panel">

                      <!-- en escritorio la razon social; en el celular el nombre corto, para que quepa -->
                      <mat-select-trigger>
                          <span class="empresa-largo">{{ empresaObj?.empresa_razon }}</span>
                          <span class="empresa-corto">{{ empresaObj?.empresa_nombre || empresaObj?.empresa_razon }}</span>
                      </mat-select-trigger>

                      <mat-option *ngFor="let empresa of empresaList" [value]="empresa">
                          {{ empresa.empresa_razon }}
                      </mat-option>

                  </mat-select>
              </mat-form-field>
          </li>

        <li class="fullscreen m-r-10 salir-item">
          <button mat-icon-button (click)="logout()" class=" nav-notification-icons"
                  matTooltip="Cerrar sesión" aria-label="Cerrar sesión">
            <mat-icon aria-hidden="true">power_settings_new</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
